import { api } from '@/api';
import type { CountriesResponse } from '../country';

export async function fetchCountries(
  locale: string
): Promise<CountriesResponse> {
  return api.get<CountriesResponse>('/v1/countries', {
    params: { locale },
  });
}
